export default __webpack_public_path__ + "static/media/03.9725aab2.jpg";